import React from "react";
import { UserConfigData } from "../../../../dto/profiledata/ProfileDataFormDTO";
import { EInputTypes, InputTextCustom } from "medere-ui-framework";

interface UserConfigTabProps {
    userConfigData:UserConfigData
    setConfigData: (userConfigData: UserConfigData) => void;
    errors?: {
        username?: boolean;
        password?: boolean;
        confirmpassword?: boolean;
    };
}

export default function UserConfigTab({userConfigData, setConfigData, errors}:UserConfigTabProps) {
    return <React.Fragment>
        <div className="config-container">
            <fieldset className="password-section">
                <h3 className="password-title">Contraseña</h3> 
                <div className="input-group">
                    <div className="input-item input-user">
                        <label style={{marginLeft: '10px'}}>Usuario</label>
                        <InputTextCustom
                            inputType={EInputTypes.TEXT}
                            value={userConfigData?.username}
                            error={errors?.username}
                            onChange={(e: any) => {setConfigData({ ...userConfigData, username: e.target.value });
                            }}
                            className="input-field input-large" 
                        />
                    </div>
                    <div className="input-item input-password">
                        <label style={{marginLeft: '10px'}}>Contraseña</label>
                        <InputTextCustom
                            inputType={EInputTypes.PASSWORD}
                            value={userConfigData?.password}
                            error={errors?.password}
                            onChange={(e: any) => {setConfigData({ ...userConfigData, password: e.target.value });
                            }}
                            className="input-field input-medium"
                        />
                    </div>
                    <div className="input-item input-password">
                        <label style={{marginLeft: '10px'}}>Confirmar contraseña</label>
                        <InputTextCustom
                            inputType={EInputTypes.PASSWORD}
                            value={userConfigData?.confirmpassword}
                            error={errors?.confirmpassword}
                            onChange={(e: any) => {setConfigData({ ...userConfigData, confirmpassword: e.target.value });
                            }}
                            className="input-field input-medium"
                        />
                    </div>
                </div>
            </fieldset>
        </div>
    </React.Fragment>
}